var _rect, _path, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 5.77808,
    fill: "#C7ABDB",
    fillOpacity: 0.31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9987 30.551C36.9987 32.7601 38.4839 34.551 35.9987 34.551C29.9987 34.551 29.0004 33.7601 29.0004 31.551C29.0004 29.3418 27.5 26.551 32.4987 26.551C34.9839 26.551 36.9987 28.3418 36.9987 30.551Z",
    fill: "#662D91",
    fillOpacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.5,
    cy: 20.551,
    rx: 2.5,
    ry: 3,
    fill: "#662D91",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6187 21.5848C23.8143 21.5848 26.4111 18.9827 26.4111 15.7924C26.4111 12.5968 23.8143 10 20.6187 10C17.4231 10 14.8263 12.5968 14.8263 15.7924C14.821 18.988 17.4231 21.5848 20.6187 21.5848ZM20.6187 11.6906C22.8763 11.6906 24.7152 13.5295 24.7152 15.7871C24.7152 18.0447 22.8763 19.8837 20.6187 19.8837C18.3611 19.8837 16.5221 18.0447 16.5221 15.7871C16.5168 13.5295 18.3558 11.6906 20.6187 11.6906ZM34.5565 26.3544C33.5973 25.8298 32.5162 25.5648 31.4404 25.5807C30.3222 25.5966 29.2252 25.9252 28.2606 26.5293C28.001 26.1901 27.7148 25.8616 27.4074 25.5542C25.5844 23.7311 23.1731 22.7295 20.6134 22.7295C18.0537 22.7295 15.6424 23.7311 13.8194 25.5542C12.0016 27.3719 11 29.7832 11 32.3429V36.254C11 36.7204 11.3816 37.1019 11.8479 37.1019H29.3842C29.8505 37.1019 30.2321 36.7204 30.2321 36.254V35.0669H36.9572C37.4236 35.0669 37.8051 34.6853 37.8051 34.219V31.8183C37.8051 29.5077 36.5915 27.462 34.5565 26.3544ZM28.5362 35.4114H12.6959V32.3482C12.6959 27.9814 16.2466 24.4254 20.6187 24.4254C24.9855 24.4254 28.5415 27.9814 28.5415 32.3482V35.4114H28.5362ZM36.1093 33.371H30.2321V32.3429C30.2321 30.7955 29.8664 29.301 29.1722 27.9602C30.5713 27.0858 32.2724 27.0434 33.7457 27.8436C35.2243 28.6491 36.1093 30.133 36.1093 31.813V33.371ZM31.5676 24.436C33.7139 24.436 35.4627 22.6871 35.4627 20.5408C35.4627 18.3945 33.7139 16.6456 31.5676 16.6456C29.4212 16.6456 27.6724 18.3945 27.6724 20.5408C27.6724 22.6871 29.4159 24.436 31.5676 24.436ZM31.5676 18.3362C32.7812 18.3362 33.7669 19.3219 33.7669 20.5355C33.7669 21.7491 32.7812 22.7348 31.5676 22.7348C30.354 22.7348 29.3683 21.7491 29.3683 20.5355C29.3683 19.3219 30.354 18.3362 31.5676 18.3362Z",
    fill: "#662D91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.d99dfcd1c890c0b8840c5ebd99eb946e.svg";
export { ForwardRef as ReactComponent };